import { Navigate, Route, Routes } from 'react-router-dom';

import AnalyticsABTestTab from 'views/Analytics/AnalyticsABTestTab/AnalyticsABTestTab';
import AnalyticsBusinessTab from 'views/Analytics/AnalyticsBusinessTab';
import AnalyticsFinanceTab from 'views/Analytics/AnalyticsFinanceTab';
import AnalyticsView from 'views/Analytics/AnalyticsView';
import CouponsView from 'views/Coupons/CouponsView';
import PackageExplorerView from 'views/PackageExplorer/PackageExplorerView';
import SegmentsView from 'views/Segments/SegmentsView';
import TestAndReleaseView from 'views/TestAndRelease/TestAndReleaseView';

import { LevelSpecificRoute } from './types';
import { ERouteContext } from './types';
import { createStoreRoutes } from './utils/storeLevelRoutesUtil';

const AnalyticsRoutes = () => (
  <Routes>
    <Route path="/" element={<AnalyticsView />}>
      <Route path="" element={<Navigate to="business" replace />} />
      <Route path="business" element={<AnalyticsBusinessTab />} />
      <Route path="finance" element={<AnalyticsFinanceTab />} />
      <Route path="ab-test" element={<AnalyticsABTestTab />} />
    </Route>
  </Routes>
);

const projectLevelSpecificRoutes: LevelSpecificRoute[] = [
  { path: 'statistics/*', element: <AnalyticsRoutes /> },
  { path: 'segments/*', element: <SegmentsView /> },
  { path: 'package-explorer/*', element: <PackageExplorerView /> },
  { path: 'test-and-release/*', element: <TestAndReleaseView /> },
  { path: 'coupons/*', element: <CouponsView /> }
];

const projectLevelRoutes = (defaultProjectPage: string) => (
  createStoreRoutes(
    'project/:publisherId',
    defaultProjectPage,
    ERouteContext.PROJECT,
    projectLevelSpecificRoutes
  )
);

export default projectLevelRoutes;
